// -----------------------------------------------------------------------------
// useLosses — Écoute temps réel des pertes (casses, périmés, etc.)
// StockPro / VisualisPro
// -----------------------------------------------------------------------------

import { useState, useEffect } from "react";
import {
  collection,
  query,
  where,
  onSnapshot,
  orderBy,
} from "firebase/firestore";

import { db, PERTES_COL } from "../firebase";

/**
 * Écoute en temps réel les pertes (logs) d'un restaurant.
 * Triés du plus récent au plus ancien.
 *
 * @param {string|null} restaurantId - ID du restaurant
 * @returns {{ pertesLogs: Array, error: Error|null }}
 */
export function useLosses(restaurantId) {
  const [pertesLogs, setPertesLogs] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!restaurantId) {
      setPertesLogs([]);
      setError(null);
      return;
    }

    const q = query(
      collection(db, PERTES_COL),
      where("restaurantId", "==", restaurantId),
      orderBy("createdAt", "desc")
    );

    const unsub = onSnapshot(
      q,
      (snapshot) => {
        setPertesLogs(snapshot.docs.map((d) => ({ id: d.id, ...d.data() })));
        setError(null);
      },
      (err) => {
        console.error("Firestore losses error:", err);
        setError(err);
      }
    );

    return unsub;
  }, [restaurantId]);

  return { pertesLogs, error };
}
